/**
 * Core global JS.
 */

// Import SCSS
import '../../scss/index.scss';

// Instantiate components
// Components
import { ComponentManager } from 'js-component-framework';

// Create instance of the component manager using `retrans-theme`
const manager = new ComponentManager('retrans-theme');

// Initialize components
document.addEventListener('DOMContentLoaded', () => {
  manager.initComponents([]); // You can supply an array of configurations to start many components at once
});

if (module.hot) {
  module.hot.accept();
  // This is required for HMR, otherwise you'll need to refresh
  // the page to see JS changes
  manager.initComponents([]);
}

